import { createStore } from '@aibees/shared/store';
import { RateLimitReachedStoreData as StoreData } from './types';

const useRateLimitReachedStore = createStore<StoreData>(
  'rate-limit-reached',
  (set) => ({
    isError: false,
    setIsError: (isError) => set({ isError }),
  })
);

export default useRateLimitReachedStore;
